import styled from 'styled-components';
import {flexRowContainerMixin} from '../../../../themes/architecture/css-helpers/flex';

export const UsefulLinksItemDefaultBox = styled.div<{active?: boolean}>`
    ${flexRowContainerMixin}
    align-items: center;
    white-space: nowrap;
    cursor: pointer;
    color: ${props => props.active ? props.theme.colors.textActive : props.theme.colors.text};
    font-size: 1.4rem;
 
    &:hover {
        color: ${props => props.theme.colors.textHover};
    }

    height: 3.75rem;
    line-height: 3.75rem;

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        display: flex;
        align-items: center;
        height: 4.5rem;
        line-height: 4.5rem;
        color: ${props => props.active ? props.theme.colors.textActive : props.theme.colors.textLight};
    }
`;
